if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"povContainer","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(7(0504|0822|7360)|86728)$/.test(chunkId)},
		rootOutputDir: "../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}